/**
 * Clave de un metadato
 */
export default class IdMetadato {
  /** @type {Number} */ idFacturae
  /** @type {Number} */ idInvoice
  /** @type {String} */ Campo
}
